module.exports = __webpack_public_path__ + "static/IBMPlexMono-Italic-389f08402cc01d177789c3a999cc9501.woff";